import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import LegalLayout from "../components/LegalLayout";
import SEO from "../components/SEO";
import { CONTACT } from "../data/mock";

export default function NoteLegali() {
  useEffect(() => {
    document.title = "Note Legali – A.C.D.T.";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative overflow-x-hidden">
      <SEO />
      <Navbar />
      <LegalLayout title="Note Legali" lastUpdate="01 Giugno 2026">
        <Section title="Informazioni sull'editore">
          <p>Il sito {CONTACT.website} è di proprietà di:</p>
          <div className="rounded-xl border border-slate-200 bg-slate-50 p-5">
            <ul className="space-y-1.5">
              <li><strong>Denominazione</strong>: {CONTACT.org}</li>
              <li><strong>Sede legale</strong>: {CONTACT.address}</li>
              <li><strong>Codice Fiscale</strong>: {CONTACT.cf}</li>
              <li><strong>Partita IVA</strong>: {CONTACT.piva}</li>
              <li><strong>Email</strong>: <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a></li>
              <li><strong>Telefono</strong>: {CONTACT.phone}</li>
            </ul>
          </div>
        </Section>

        <Section title="Inquadramento normativo">
          <p>
            A.C.D.T. è un'associazione professionale che opera ai sensi della Legge 14/01/2013, n. 4,
            in materia di professioni non organizzate in ordini o collegi.
          </p>
          <p>
            L'Associazione è iscritta nell'elenco delle forme aggregative del Ministero delle
            Imprese e del Made in Italy (MIMIT) tramite il Centro Studi E.S.S.E.
          </p>
        </Section>

        <Section title="Proprietà intellettuale">
          <p>
            Tutti i contenuti presenti sul sito (testi, immagini, grafica, logo, marchi, video)
            sono di proprietà di {CONTACT.org} o dei rispettivi titolari e sono tutelati dalle norme
            in materia di diritto d'autore e proprietà industriale.
          </p>
          <p>
            È vietata la riproduzione, anche parziale, senza autorizzazione scritta.
          </p>
        </Section>

        <Section title="Marchi e loghi di terzi">
          <p>
            I marchi MIMIT, Centro Studi E.S.S.E., Pigreco Formazione, AIRC e gli eventuali marchi
            citati appartengono ai rispettivi titolari e sono utilizzati a scopo informativo
            e descrittivo.
          </p>
        </Section>

        <Section title="Limitazione di responsabilità">
          <p>
            L'Associazione si impegna a mantenere aggiornate le informazioni pubblicate sul sito,
            ma non garantisce l'assenza di errori, omissioni o ritardi.
            L'utilizzo delle informazioni pubblicate è a discrezione e responsabilità dell'utente.
          </p>
        </Section>

        <Section title="Link esterni">
          <p>
            Il sito può contenere link a siti web di terzi. {CONTACT.org} non controlla e non è
            responsabile dei contenuti, della disponibilità o delle politiche privacy di tali siti.
          </p>
        </Section>
      </LegalLayout>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="mb-8">
      <h2 className="text-xl md:text-2xl font-extrabold text-[#0a1f55] mb-3">{title}</h2>
      <div className="text-[15px] text-slate-700 leading-relaxed space-y-3 [&_a]:text-[#102a6b] [&_a]:underline [&_a]:font-semibold [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:list-decimal [&_ol]:pl-6 [&_ul]:space-y-1.5 [&_ol]:space-y-1.5">
        {children}
      </div>
    </section>
  );
}
